<template>
	<div class="products__category-header">
		<a
			ref="anchor"
			class="anchor"
			:id="`category-${category.code}`"
		/>
		<div
			class="products__category-header-bg"
		>
			<img
				class="products__category-header-bg-image"
				:src="category.headerImage"
				alt="category header image"
				loading="lazy"
			/>
		</div>
		<div class="products__category-header-content">
			<component
				v-if="iconComponent(category.svgIconKey)"
				:is="iconComponent(category.svgIconKey)"
				class="products__category-header-icon"
			/>
			<SVGInfo
				v-else
				class="products__category-header-icon"
			/>

			<h2
				class="products__category-header-title"
				v-html="category.name"
			/>
		</div>
	</div>
</template>

<script>
import scrrroll from 'scrrroll'

export default {
	props: {
		category: Object
	},
	methods: {
		scrollTo(speed = 300) {
			scrrroll.to(this.$refs.anchor, speed);
		}
	}
}
</script>

<style>

</style>
